// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"PageSpinner-module--flexContainer--39mPP"};